module.exports = __webpack_public_path__ + "img/Corrupted_Image.4dbf6316.png";